<template>
    <div class="collection">
        <header>
            <div class="header">
                <h2>我的收藏</h2>
            </div>
            <div class="line"></div>
            <div class="input_box">
                <input type="text" v-model="queryParams.modelName" @change="query();" placeholder="请输入资产名称" />
                <van-icon name="search" color="#969696" size="20" />
            </div>
            <div class="tabs">
                <span @click="queryParams.assetType = 1; query();" :class="{active: queryParams.assetType == 1}">模型收藏</span>
                <span @click="queryParams.assetType = 2; query();" :class="{active: queryParams.assetType == 2}">作品收藏</span>
            </div>
        </header>
        <div class="query_box">
            <span @click="() => sortPickerRef.openPicker()">模型排序 <van-icon name="arrow-down" /></span>
        </div>
        <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
            <ul class="list">
                <li v-for="item in list" :key="item.id">
                    <AssetsCard :item="item" />
                </li>
            </ul>
        </van-list>
    </div>
    <SortPicker ref="sortPickerRef" @confirm="d => {queryParams.modelSort = d[0].id; query();}" />
</template>

<script setup>
import { http } from '@/request/http'
import { useStore } from 'vuex'
import { onMounted, reactive, ref, toRaw, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import AssetsCard from './AssetsCard.vue'
import SortPicker from '@/views/workbench/components/sortPicker.vue'

const sortPickerRef = ref(null)

const router = useRouter()
const store = useStore()
const queryParams = reactive({
    assetType: 1,
    modelSort: '',
    modelName: ''
})
const pagination = reactive({
    pageNo: 1,
    pageSize: 10
})
const total = ref(0)
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const fetchList = () => {
    loading.value = true
    http.get('/app-api/product/favorite/page', {
        params: Object.assign({}, queryParams, pagination)
    }).then(res => {
        loading.value = false
        finished.value = res.list.length < pagination.pageSize
        total.value = res.total
        list.value = [...list.value, ...res.list]
    })
}
const onLoad = () => {
    pagination.pageNo++
    fetchList()
}
const query = () => {
    pagination.pageNo = 1
    list.value = []
    finished.value = false
    fetchList()
}
onMounted(() => {
    fetchList()
})

</script>

<style lang="scss" scoped>
@use '../common.scss';

.collection {
    background-color: #F6F6F6;
    min-height: 100vh;
    header {
        padding: 15rem;
        background-color: #fff;

        .header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            img {
                height: 29rem;
            }
        }
    }
    .query_box {
        padding: 15rem;
        display: flex; justify-content: flex-end;
    }
    .list {
        padding-bottom: 50rem;
        padding: 15rem;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-gap: 15rem;
        li{
            background-color: #fff;
        }
    }
}
</style>